import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaWigilieFirmowa = () => (
  <SeoPageLayout title="Kabaret na wigilię firmową - świąteczna rozrywka dla zespołu">
    <p>
      Wigilia firmowa to jedno z najważniejszych wydarzeń w kalendarzu każdej firmy. To czas podsumowań, podziękowań i wspólnego świętowania. Kabaret na wigilię firmową to atrakcja, która doda świątecznego blasku i sprawi, że spotkanie będzie naprawdę wyjątkowe.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Świąteczny kabaret - humor w bożonarodzeniowej oprawie</h2>
    <p>
      Nasi artyści przygotowują specjalne programy świąteczne, które łączą klasyczny humor kabaretowy z tematyką bożonarodzeniową. Żarty o firmowych prezentach, noworocznych postanowieniach, świątecznych tradycjach i zimowych perypetiach tworzą magiczną atmosferę pełną śmiechu.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Dlaczego warto zamówić kabaret na wigilię firmową?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Przełamuje formalną atmosferę i pozwala pracownikom się zrelaksować</li>
      <li>Idealnie wypełnia czas między oficjalną częścią a zabawą</li>
      <li>Tworzy wspólne pozytywne wspomnienia z końca roku</li>
      <li>Pracownicy czują się docenieni - firma inwestuje w ich rozrywkę</li>
      <li>Humor łączy ludzi z różnych działów, którzy na co dzień rzadko się spotykają</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kiedy zarezerwować kabaret na wigilię firmową?</h2>
    <p>
      Okres świąteczny to szczyt sezonu kabaretowego - terminy rezerwowane są z dużym wyprzedzeniem. Zalecamy kontakt już we wrześniu lub październiku, aby zapewnić dostępność artystów w wybranym terminie. Im wcześniej zarezerWujesz, tym większy wybór artystów i terminów.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Format występu na wigilię</h2>
    <p>
      Na wigilię firmową rekomendujemy występ trwający 30-45 minut, zaplanowany po części oficjalnej - przemówieniach, podziękowaniach i wręczeniu upominków. Kabaret płynnie przechodzi od oficjalnej atmosfery do luźnej zabawy, tworząc naturalny most między częściami programu.
    </p>
  </SeoPageLayout>
);

export default KabaretNaWigilieFirmowa;
